import { useEffect, useRef, useState } from "react"
import "./logo-animation.component.css"

const LogoAnimation = (props) => {
  const { id, IntroDelay, DelayBetweenAnimations } = props
  const timerRef = useRef()
  const [selectedAnimation, setSelectedAnimation] = useState()
  const [upcomingAnimation, setUpcomingAnimation] = useState()
  const currentIndexRef = useRef(0)
  const upcomingIndexRef = useRef(1)
  const animationsRef = useRef()
  const elRef = useRef()
  const upcomingRef = useRef()
  const isPlayingRef = useRef("current")

  const updateFirstRef = () => {
    let index
    if (upcomingIndexRef.current + 1 < animationsRef.current.length) {
      index = upcomingIndexRef.current + 1
    } else {
      index = 0
    }
    currentIndexRef.current = index
    setSelectedAnimation(animationsRef.current[index])
  }

  const prepareSecondAnimation = () => {
    let index
    if (currentIndexRef.current + 1 < animationsRef.current.length) {
      index = currentIndexRef.current + 1
    } else {
      index = 0
    }

    upcomingIndexRef.current = index
    setUpcomingAnimation(animationsRef.current[index])
  }

  // Get items on load
  useEffect(() => {
    const store = window.sessionStorage.getItem("__dagger-store__")
    if (store) {
      animationsRef.current = JSON.parse(store).animations
      if (animationsRef.current.length > 1) {
        setSelectedAnimation(animationsRef.current[0])
        setUpcomingAnimation(animationsRef.current[1])
      }
    }
  }, [])

  const handleVideoComplete = () => {
    // Swap animations
    let toPlayRef
    if (isPlayingRef.current === "current") {
      console.log("on animation " + currentIndexRef.current + " complete...")
      upcomingRef.current.classList.remove("upcoming-animation")
      elRef.current.classList.add("upcoming-animation")
      toPlayRef = upcomingRef.current
      isPlayingRef.current = "upcoming"
      updateFirstRef()
    } else {
      console.log("on animation " + upcomingIndexRef.current + " complete...")
      upcomingRef.current.classList.add("upcoming-animation")
      elRef.current.classList.remove("upcoming-animation")
      toPlayRef = elRef.current
      isPlayingRef.current = "current"
      prepareSecondAnimation()
    }

    // Play after swap delay
    const sanitizedDelay = DelayBetweenAnimations
      ? DelayBetweenAnimations * 1000
      : 3500
    timerRef.current = setTimeout(() => {
      toPlayRef.play()
    }, sanitizedDelay)
  }

  useEffect(() => {
    const sanitizedDelay = IntroDelay ? IntroDelay * 1000 : 0
    setTimeout(() => {
      elRef.current.play()
    }, sanitizedDelay)

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
        timerRef.current = null
      }
    }
  }, [IntroDelay])

  return (
    <>
      <div
        className={
          id
            ? `dagger-logo-animation-container dagger-logo-${id}`
            : "dagger-logo-animation-container"
        }
      >
        <div className="logo-animation-container">
          <div className="logo-animation">
            {selectedAnimation && (
              <video
                ref={elRef}
                muted
                playsInline
                src={`${selectedAnimation}#t=0.1`}
                onEnded={handleVideoComplete}
              />
            )}
            {upcomingAnimation && (
              <video
                ref={upcomingRef}
                muted
                playsInline
                src={`${upcomingAnimation}#t=0.1`}
                onEnded={handleVideoComplete}
                className="upcoming-animation"
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default LogoAnimation
